import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'thailand/phuket_rooftop.jpg' satisfies MediaPath
const p1 = 'thailand/IMG_20191109_175431.jpg' satisfies MediaPath
const p2 = 'thailand/IMG_20191114_101811.jpg' satisfies MediaPath
const p3 = 'az/IMG_20201010_124504.jpg' satisfies MediaPath
const p4 = 'ut/PXL_20210309_010516294.jpg' satisfies MediaPath

export const meta: EntryMeta = {
	slug: 'abroad',
	name: 'Abroad',
	excerpt: 'A small glimpse of a big world',
	tags: ['photography'],
	cover,
	featured: true,
	order: 20,
}

export default function Abroad() {
	return (
		<>
			<p>
				Frames collected wandering rooftops, markets, and coastlines. Thumbnails are optimized for
				the web — each opens to a larger view with a link to the full-resolution file.
			</p>
			<Gallery
				items={[
					{ src: p1, alt: 'Evening street' },
					{ src: p2, alt: 'Harbor light' },
					{ src: p3, alt: 'Hillside' },
					{ src: p4, alt: 'Rooftop dusk' },
				]}
			/>
		</>
	)
}
